import { render, staticRenderFns } from "./_splash.vue?vue&type=template&id=56411afa&scoped=true"
import script from "./_splash.vue?vue&type=script&lang=js"
export * from "./_splash.vue?vue&type=script&lang=js"
import style0 from "./_splash.vue?vue&type=style&index=0&id=56411afa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56411afa",
  null
  
)

export default component.exports